import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icon_14.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "wh-20",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_2 = { class: "fz-14 color-primary ml-8" }

import translate from '@/api/translate';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'ListDel',
  emits: ["change"],
  setup(__props, { emit: __emit }) {

	const emits = __emit;

	const Operate = () => {
		emits("change");
	};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex-row-center-start ml-20 h-32 pointer",
    onClick: Operate
  }, [
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(translate).ShowText('删除')), 1)
  ]))
}
}

})